// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-tab .color-tab-bar[data-v-f2e32fe2]{position:absolute;height:0;width:0}.v-tab .tab-text[data-v-f2e32fe2]{color:#747474}.v-tab--active .color-tab-bar[data-v-f2e32fe2]{position:absolute;height:4px!important;width:100%!important;bottom:0;left:0}.v-tab--active .tab-text[data-v-f2e32fe2]{color:#000}.v-tab--active[data-v-f2e32fe2]{background-color:#f1f1f1!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
